// ============================================================================
// UOM (Unit of Measure) API TYPES — aligned with Fbp.Core.DTOs.Common.UomDto.
// common.tbl_uom via /api/v1/common/uoms: the read list every UoM picker uses,
// and the Units of Measure screen's writes (ADR-0058 slice 1).
// Tenant-wide (not entity-scoped).
// ============================================================================

export type UomCategory = 'TIME' | 'COUNT' | 'WEIGHT' | 'VOLUME' | 'LENGTH' | 'AREA' | 'OTHER';

export const UOM_CATEGORIES: UomCategory[] = ['COUNT', 'WEIGHT', 'VOLUME', 'LENGTH', 'AREA', 'TIME', 'OTHER'];

export interface UomDto {
  id: string;
  uomCode: string;
  uomName: string;
  symbol?: string | null;
  /** TIME | COUNT | WEIGHT | VOLUME | LENGTH | AREA | OTHER. */
  category: string;
  decimalPlaces: number;
  /** UN/ECE Recommendation 20 code (HUR, KGM, LTR). */
  isoCode?: string | null;
  sortOrder: number;
  /** Seeded unit: code fixed, cannot be deleted. */
  isSystem: boolean;
  description?: string | null;
  rowVersion: number;
  updatedByName?: string | null;
  updatedAt?: string | null;
  /** Items using the unit as base unit or pack; delete is refused while > 0. */
  usageCount: number;
}

export interface CreateUomRequest {
  uomCode: string;
  uomName: string;
  symbol?: string | null;
  category: UomCategory;
  decimalPlaces: number;
  isoCode?: string | null;
  sortOrder: number;
  description?: string | null;
}

export interface UpdateUomRequest extends CreateUomRequest {
  rowVersion: number;
}
